import { Box, Flex } from '@mantine/core';

import { SENDING_INDICATOR_DOT_COUNT } from '@constants';
import classes from './SendingIndicator.module.css';

interface SendingIndicatorProps {
  isContrast?: boolean;
  inSyncMode?: boolean;
  'data-pw'?: string;
}

export const SendingIndicator: React.FC<SendingIndicatorProps> = ({ isContrast, inSyncMode, 'data-pw': dataPw }) => {
  return (
    <Flex className={classes.container} data-pw={dataPw}>
      {Array(SENDING_INDICATOR_DOT_COUNT)
        .fill(0)
        .map((_, index) => (
          <Box key={`spinner-dot-${index}`} className={classes.dot} top={inSyncMode ? '2px' : '8px'}>
            <span className={isContrast ? classes.dotContrast : classes.dotPrimary} />
          </Box>
        ))}
      <Box className={`${classes.arrowRight} ${isContrast ? classes.arrowContrast : classes.arrowPrimary}`} top={inSyncMode ? '1px' : 'unset'} />
    </Flex>
  );
};
